import React, { createContext, useState, useMemo, useCallback } from "react";

const initial_contentsList = {
  page: 0,
  per_page: 0,
  total: 0,
  pages: 0,
  items: [],
};

const initial_content = {};

export const ContentsContext = createContext({
  // States
  allCategories: [],
  setAllCategories: () => {},
  categories: [],
  setCategories: () => {},
  isProAthleteContent: false,
  setIsProAthleteContent: () => {},
  content: initial_content,
  setContent: () => {},
  contentsList: initial_contentsList,
  setContentsList: () => {},
  page: 1,
  setPage: () => {},
  zoneId: null,
  setZoneId: () => {},
  query: "",
  setQuery: () => {},
  Allcontributing_factors: [],
  setAllContributingFactors: () => {},
  allFocusAreas: [],
  setAllFocusAreas: () => {},
  allTags: [],
  setTags: () => {},

  //  Functions
  filterCategories: () => {},
  resetValues_ContentsList: () => {},
  resetValues_Content: () => {},
});

//Provider
export const ContentsProvider = ({ children }) => {
  const [allCategories, setAllCategories] = useState([]);
  const [allContributing_factors, setAllContributingFactors] = useState([]);
  const [allFocusAreas, setAllFocusAreas] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isProAthleteContent, setIsProAthleteContent] = useState(false);
  const [content, setContent] = useState({});
  const [contentsList, setContentsList] = useState({
    page: 0,
    per_page: 0,
    total: 0,
    pages: 0,
    items: [],
  });
  const [page, setPage] = useState(1);
  const [zoneId, setZoneId] = useState(null);
  const [query, setQuery] = useState("");

  // Functions
  const filterCategories = useCallback(
    (isProAthlete) => {
      setCategories(
        allCategories.filter((x) => x.is_pro_athlete === isProAthlete)
      );
    },
    [allCategories]
  );
  const resetValues_ContentsList = useCallback(() => {
    setContentsList(initial_contentsList);
  }, []);
  const resetValues_Content = useCallback(() => {
    setContent(initial_content);
  }, []);

  // Values
  const value = useMemo(
    () => ({
      allCategories,
      setAllCategories,
      categories,
      setCategories,
      filterCategories,
      resetValues_ContentsList,
      resetValues_Content,
      isProAthleteContent,
      setIsProAthleteContent,
      content,
      setContent,
      contentsList,
      setContentsList,
      page,
      setPage,
      zoneId,
      setZoneId,
      query,
      setQuery,
      allContributing_factors,
      setContributingFactors: setAllContributingFactors,
      allFocusAreas,
      setAllFocusAreas,
      allTags,
      setAllTags,
    }),
    [
      allCategories,
      categories,
      filterCategories,
      resetValues_ContentsList,
      resetValues_Content,
      isProAthleteContent,
      content,
      contentsList,
      page,
      zoneId,
      query,
      allContributing_factors,
      allFocusAreas,
      allTags,
    ]
  );

  return (
    <ContentsContext.Provider value={value}>
      {children}
    </ContentsContext.Provider>
  );
};
